(() => {
  const desktopMedia = window.matchMedia('(min-width: 990px)');

  function createButton(className, label, symbol) {
    const button = document.createElement('button');

    button.type = 'button';
    button.className = `ala-product-gallery__button ${className}`;
    button.setAttribute('aria-label', label);
    button.innerHTML = `<span aria-hidden="true">${symbol}</span>`;

    return button;
  }

  function initializeGallery(gallery) {
    if (gallery.dataset.alaProductGalleryReady === 'true') return;
    if (!gallery.dataset.desktopLayout?.includes('thumbnail')) return;

    const viewer = gallery.querySelector(
      'slider-component[id^="GalleryViewer-"]'
    );

    const thumbnailSlider = gallery.querySelector(
      'slider-component[id^="GalleryThumbnails-"]'
    );

    const thumbnailList = thumbnailSlider?.querySelector(
      '[id^="Slider-Thumbnails-"]'
    );

    if (!viewer || !thumbnailSlider || !thumbnailList) return;

    gallery.dataset.alaProductGalleryReady = 'true';

    const mainPrevious = createButton(
      'ala-product-gallery__button--main-prev',
      'Önceki ürün görseli',
      '‹'
    );

    const mainNext = createButton(
      'ala-product-gallery__button--main-next',
      'Sonraki ürün görseli',
      '›'
    );

    const thumbnailPrevious = createButton(
      'ala-product-gallery__button--thumb-prev',
      'Önceki küçük görsel',
      '▲'
    );

    const thumbnailNext = createButton(
      'ala-product-gallery__button--thumb-next',
      'Sonraki küçük görsel',
      '▼'
    );

    viewer.append(mainPrevious, mainNext);
    thumbnailSlider.append(thumbnailPrevious, thumbnailNext);

    function getThumbnails() {
      return Array.from(
        thumbnailList.querySelectorAll('[data-target]')
      ).filter(
        (item) =>
          !item.hidden &&
          window.getComputedStyle(item).display !== 'none'
      );
    }

    function getCurrentIndex(items) {
      const currentIndex = items.findIndex((item) =>
        item.querySelector('button[aria-current="true"]')
      );

      return currentIndex >= 0 ? currentIndex : 0;
    }

    function scrollThumbnailIntoView(item) {
      const itemTop = item.offsetTop;
      const itemBottom = itemTop + item.offsetHeight;
      const visibleTop = thumbnailList.scrollTop;
      const visibleBottom = visibleTop + thumbnailList.clientHeight;

      if (itemTop < visibleTop) {
        thumbnailList.scrollTo({
          top: Math.max(itemTop - 4, 0),
          behavior: desktopMedia.matches ? 'smooth' : 'auto',
        });
      } else if (itemBottom > visibleBottom) {
        thumbnailList.scrollTo({
          top: itemBottom - thumbnailList.clientHeight + 4,
          behavior: desktopMedia.matches ? 'smooth' : 'auto',
        });
      }
    }

   let currentSlideAnimation = null;

function animateActiveMedia(direction) {
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  if (reducedMotion.matches) return;

  const activeMedia = viewer.querySelector(
    '.product__media-item.is-active'
  );

  if (!activeMedia || typeof activeMedia.animate !== 'function') return;

  currentSlideAnimation?.cancel();

  const startPosition = direction > 0 ? '4rem' : '-4rem';

  const animation = activeMedia.animate(
    [
      {
        opacity: 0.4,
        transform: `translateX(${startPosition})`,
      },
      {
        opacity: 1,
        transform: 'translateX(0)',
      },
    ],
    {
      duration: 2500,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      fill: 'both',
    }
  );

  currentSlideAnimation = animation;

  animation.addEventListener(
    'finish',
    () => {
      animation.cancel();

      if (currentSlideAnimation === animation) {
        currentSlideAnimation = null;
      }
    },
    { once: true }
  );
}

function changeImage(direction) {
  if (!desktopMedia.matches) return;

  const items = getThumbnails();
  if (items.length < 2) return;

  const currentIndex = getCurrentIndex(items);
  const nextIndex =
    (currentIndex + direction + items.length) % items.length;

  const nextItem = items[nextIndex];
  const nextButton = nextItem.querySelector('button');

  if (!nextButton) return;

  nextButton.click();
  animateActiveMedia(direction);

  window.requestAnimationFrame(() => {
    scrollThumbnailIntoView(nextItem);
  });
}

    mainPrevious.addEventListener('click', () => changeImage(-1));
    mainNext.addEventListener('click', () => changeImage(1));
    thumbnailPrevious.addEventListener('click', () => changeImage(-1));
    thumbnailNext.addEventListener('click', () => changeImage(1));

    thumbnailList.addEventListener('click', (event) => {
      const item = event.target.closest('[data-target]');
      if (!item) return;

      window.requestAnimationFrame(() => {
        scrollThumbnailIntoView(item);
      });
    });
  }

  function initializeAll(root = document) {
    root
      .querySelectorAll(
        'media-gallery[data-desktop-layout*="thumbnail"]'
      )
      .forEach(initializeGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll(),
      { once: true }
    );
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();